import {Component, OnInit, AfterViewInit, Output, EventEmitter, Input} from '@angular/core';
import {PlatformLocation} from '@angular/common';

@Component({
  selector: 'app-break-point',
  templateUrl: './app-break-point.component.html',
  styleUrls: ['./app-break-point.component.css',]
})
export class AppBreakPointComponent implements OnInit , AfterViewInit {
  @Input() userBreakPoint: any;
  @Input() assetsRoute: string;
  @Output() closeAppBreakPoint = new EventEmitter<any>(); //回传标签
  courseName: string;
  courseModule: string;
  isClicked: boolean = true;

  constructor(
    private platformLocation: PlatformLocation
  ) {}

  ngOnInit() {
    console.log(this.userBreakPoint);
    localStorage.setItem("learningPathMetaId",this.userBreakPoint.learningPathMetasId)
    this.courseName = this.userBreakPoint.learningPathMetasName;
    this.courseModule = {1:'能力诊断',2:'课程学习',3:'情景模拟',4:'能力考核'}[Number(this.userBreakPoint.moduleId)] || '暂无记录';
  }

  ngAfterViewInit(){

  }

  //继续学习
  continueLearning():void{
    if(!this.isClicked){
     return;
    }else{
      let targetUrl = this.userBreakPoint.breakpointUrl;
      // 清除URL中的token和userIdEncoder参数，防止旧token覆盖新token
      targetUrl = this.removeUrlParam(targetUrl, 'token');
      targetUrl = this.removeUrlParam(targetUrl, 'userIdEncoder');

      this.platformLocation['location']['href'] = targetUrl;
      this.isClicked = false;
    }
  }

  removeUrlParam(url: string, param: string): string {
    const urlParts = url.split('?');
    if (urlParts.length >= 2) {
      const prefix = urlParts.shift();
      const queryString = urlParts.join('?');
      const params = queryString.split(/[&;]/g);
      const newParams = [];
      for (let i = 0; i < params.length; i++) {
        const keyValuePair = params[i].split('=');
        if (keyValuePair[0] !== param) {
          newParams.push(params[i]);
        }
      }
      return prefix + (newParams.length > 0 ? '?' + newParams.join('&') : '');
    }
    return url;
  }

  //关闭
  close():void{
    if(!this.isClicked){
      return;
    }else{
      this.closeAppBreakPoint.emit();
      this.isClicked = false;
      // 清除项目相关信息
      localStorage.removeItem("projectmsg")
      localStorage.removeItem("projectId")
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/app-break-point/app-break-point.component.ts